'use strict';
import isEqual from 'lodash/isEqual';


export class Role {

  /**
   *
   * @param {Object<String, Boolean>} permissions
   */
  constructor(permissions) {
    this.permissions = permissions;
  }

  /**
   * @param {String} permission
   * @returns {Boolean}
   */
  hasPermission(permission) {
    return this.permissions[permission] || false;
  }
}

export function isRoleDataChanged(a, b) {
  if (!a && !b) {
    return true;
  } else if (!a || !b) {
    return false;
  } else {
    return isEqual(a.permissions, b.permissions);
  }
}



// WEBPACK FOOTER //
// ./src/js/auth/services/Role.js